// extracted by mini-css-extract-plugin
module.exports = {"emoji":"Emoji_emoji__XJVVi","emoji__content":"Emoji_emoji__content__IMcOz"};